/**
 * @desc centerID国家映射导出数据
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  body: defs.basics.CenterCountyMappingRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/centerCountyMapping/export`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
